const hijri = require("hijri");
let keepGoing = true;
function drawCalacateHijri(data) {
  let result = [];
  let TODAY = hijri.convert(new Date());
  for (let index = 0; index < 35; index++) {
    result.push({ col: null, state: false, dayOfWeek: index + 1 });
  }
  let START_AT = data.date[0].dayOfWeek;
  let SAVE_INDEX = 0;

  for (let index = 0; index < result.length; index++) {
    let element = result[index];

    if (START_AT === element.dayOfWeek) {
      SAVE_INDEX = index;

      break;
    }
  }
  for (let index = 0; index < data.date.length; index++) {
    const element = data.date[index];

    result[SAVE_INDEX] = {
      ...element,
      id: "month-" + data.month + "-" + element.dayOfMonth + "-" + SAVE_INDEX,
      col: element.dayOfMonth,
      state: true,
      // state: true,
    };
    const IF_CURRENT_DAY =
      TODAY.dayOfMonth - 1 == element.dayOfMonth && TODAY.month == data.month;
    // ${TODAY.month} === ${data.month}`);
    if (IF_CURRENT_DAY) result[SAVE_INDEX].current_today = true;

    SAVE_INDEX++;
  }
  return result; // let calnder = getAllHijirDate()[1];
}
export default drawCalacateHijri;
